import React from 'react';
import { Section } from './Section';
const steps = [{
  num: 'I',
  title: 'Identificación',
  desc: 'Localizas los anclajes emocionales por donde te están manipulando hoy.'
}, {
  num: 'II',
  title: 'Neutralización',
  desc: 'Aplicas el Escudo Cognitivo para detener la filtración de poder de inmediato.'
}, {
  num: 'III',
  title: 'Integración',
  desc: 'Activas tus leyes de sombra para moverte con seguridad, misterio y autoridad.'
}];
export function HowItWorks() {
  return <Section className="max-w-5xl" data-id="element-120">
      <div className="text-center mb-16" data-id="element-121">
        <span className="text-blood font-sans text-xs font-bold tracking-widest uppercase mb-4 block" data-id="element-122">
          El Proceso
        </span>
        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-foreground" data-id="element-123">
          Cómo funciona
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 relative" data-id="element-124">
        <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-[1px] bg-border z-0" data-id="element-125"></div>

        {steps.map((step, i) => <div key={i} className="relative z-10 flex flex-col items-center text-center" data-id="element-126">
            <div className="w-24 h-24 bg-background border border-border rounded-full flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(0,0,0,0.8)]" data-id="element-127">
              <span className="text-3xl font-serif text-blood font-bold" data-id="element-128">
                {step.num}
              </span>
            </div>
            <h3 className="text-2xl font-serif font-bold mb-4 text-foreground" data-id="element-129">
              {step.title}
            </h3>
            <p className="text-foreground/70 font-sans font-light leading-relaxed" data-id="element-130">
              {step.desc}
            </p>
          </div>)}
      </div>
    </Section>;
}